import {
  SHOW_FORM_MESSAGE,
  HIDE_FORM_MESSAGE,
  ON_SHOW_LOADER,
  ON_HIDE_LOADER,
  GET_FORM_SUCCESS,
  GET_CLIENT_INFO_SUCCESS,
} from '../constants/ActionTypes'

const INIT_STATE = {
  loader: false,
  alertMessage: '',
  showMessage: false,
  formData: {},
  clientInfo: {},
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_FORM_SUCCESS: {
      return {
        ...state,
        loader: false,
        formData: action.payload.data,
      }
    }

    case GET_CLIENT_INFO_SUCCESS: {
      return {
        ...state,
        loader: false,
        clientInfo: action.payload,
      }
    }

    case SHOW_FORM_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
        loader: false,
      }
    }

    case HIDE_FORM_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessage: false,
        loader: false,
      }
    }

    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true,
      }
    }

    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false,
      }
    }

    default:
      return state
  }
}
